module.exports = __webpack_public_path__ + "img/ITEMNG.a46fe9c7.png";